import { useForm } from 'react-hook-form';
import Loader from 'react-loader-spinner';
import { Button, Col, Form, Modal, Table } from 'react-bootstrap';
import { Accordion, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { Check2All, Check2Square, CheckLg, PersonPlus, Search } from "react-bootstrap-icons";
import React, { useEffect, useState, useRef } from 'react';
import { getAllProvinces, getCityList } from '../../store/api/LocationAPI';
import { searchCustomer4Modal, checkNationalCode, addNewCustomer } from '../../CRM/store/api/CustomerApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { getSettingValue, isWebApp, setErrorDialog, useIsMobileApp } from '../../store/api/CommonFunctions';
import BihamtaTable from "../BihamtaTable";
import { getSystemSettingsAsync, getSystemSettingsByCallback } from '../../store/api/SystemSettingsAPI';
/**
 * @component
 * @param {Object} props 
 * @param {boolean} props.nationalCodeIsRequired
 * @param {function} props.setCustomerPopup
 * @param {{
    * show:boolean, 
    * value:string, 
    * setCustomerLocation:function, 
    * invoiceCustomers:boolean,
    *  justStaff:boolean, 
    * justForSelect:boolean, 
    * defaultAccType:boolean,
    * multiSelect:boolean}} props.popData
 * @returns 
 */
const ModalSelectCustomer = ({ nationalCodeIsRequired, setCustomerPopup, popData }) => {
    const { handleSubmit, register } = useForm();
    const { show, value, setCustomerData, setCustomerLocation, invoiceCustomers, justStaff, justForSelect, defaultAccType, multiSelect } = popData;
    const { provinceList, cityList } = useSelector(state => {
        return {
            provinceList: state.locationDataReducer?.provinceList,
            cityList: state.locationDataReducer?.cityList,
            zoneList: state.locationDataReducer?.zoneList,
            currentLocation: state.locationDataReducer?.currentLocation
        }
    });
    const [settings, setSettings] = useState([]);

    const resultTable = useRef();
    const refInputCustName = useRef();
    const isMobile = useIsMobileApp();
    const [isPending, setPending] = useState(false);
    const [customerList, getData] = useState([]);
    const customerData = useRef({});
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [custType, setCustType] = useState('');
    const [err, setError] = useState({});
    const searchData = useRef();
    const [accType, setAccType] = useState("");
    const title = justStaff ? "تکنسین/نماینده" : "طرف حساب";
    const dispatch = useDispatch();
    const settingNames = ["DefaultAccTypeInCustomerSelect"];
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: false, styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "Code", colTitle: "کد " + title, showInMobile: true, styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "FirstName+Name", colTitle: "نام " + title, seprator: ' ', showInMobile: true, colType: "string", styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "Phone+Mobile", colTitle: "شماره تماس", colType: "string", styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "NationalCode", colTitle: "شماره ملی", styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "SubscriptionCode", colTitle: "شماره اشتراک", showCondition: () => invoiceCustomers, styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "Address", colTitle: "نشانی", colType: "string", maxTextLength: 20, hasTooltip: true, style: { fontSize: "10px" } },
        { colName: "CustOrPreCust", colTitle: "مشتری/بالقوه", showCondition: () => !invoiceCustomers, styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} }
    ]
    const rowButtons = [];
    if (isMobile) {
        rowButtons.push(
            { title: "انتخاب طرف حساب", type: "common", className: "group-Btn-smalll btn-info", onclick: select, icon: <Check2Square size={18} className="rowBtn" color="#007b80" /> },
        )
    }
    function closeModal() {
        setSelectedCustomers([]);
        customerData.current = {};
        setCustomerData(null);
        setCustomerPopup({ show: false });
    }
    const loadCityList = (provinceID) => {
        dispatch(getCityList(provinceID));
    }
    const submit = (gotoCustomer) => {
        if (isPending) {
            return;
        }
        const nameIsEmpty = (customerData.current.Name ?? "") === '';
        const nationalIsEmpty = nationalCodeIsRequired && ((customerData.current.NationalCode ?? "") === '' || (customerData.current.Type !== 'حقوقی' && !checkNationalCode(customerData.current.NationalCode)));
        const addresIsEmpty = (customerData.current.Address ?? "") === '';
        const phoneOrMobileIsEmpty = (customerData.current.Phone ?? "") === '' && (customerData.current.Mobile ?? "") === '';

        setError({
            Name: nameIsEmpty ? 'N' : null,
            NationalCode: nationalIsEmpty ? 'N' : null,
            Address: addresIsEmpty ? 'N' : null,
            Mobile: phoneOrMobileIsEmpty ? 'N' : null,
        });
        if (nameIsEmpty || nationalIsEmpty || addresIsEmpty || phoneOrMobileIsEmpty) {
            return;
        }
        customerData.current.Cat = 3;

        const onAdd = (res) => {
            //res.Name = (res.FirstName ?? "") + " " + res.Name;

            setPending(false);
            select(res);
            if (gotoCustomer && res) {
                window.open("/CRM/AddEditCustomer/" + res.ID);
            }
        }
        setPending(true);
        customerData.current.CustomerAccountType = accType;

        dispatch(addNewCustomer(customerData.current, onAdd));
    }
    const search = (data) => {
        data.Take = data.Take ?? 100;
        data.Skip = 0;
        data.JustStaff = justStaff ?? false;
        data.InvoiceCustomers = invoiceCustomers;
        data.JustCustomers = !invoiceCustomers;
        //data.IsBlackListed = false;
        searchData.current = data;
        searchCustomer4Modal(data, getData);
    }
    function select(item) {
        if (multiSelect && !item && selectedCustomers?.length > 0) {
            setCustomerData([...selectedCustomers]);
            customerData.current = {};
            setSelectedCustomers([]);
            setCustomerPopup({ show: false });
            return;
        }
        if (item.IsBlackListed) {
            setErrorDialog(dispatch, "این مشتری در لیست سیاه قرار دارد.", "انتخاب مشتری", 1200);
        }
        if (multiSelect) {
            if (item.ctrlIsDown) {
                const found = selectedCustomers.find(c => Number(c.ID) === Number(item.ID));
                if (found) {
                    resultTable.current.rows[item.RowIndex + 1].className = "resultTableRow";
                    setSelectedCustomers(selectedCustomers.filter(c => Number(c.ID) !== Number(item.ID)));
                }
                else {
                    resultTable.current.rows[item.RowIndex + 1].className = "selectedResultTableRow";
                    setSelectedCustomers([...selectedCustomers, item]);
                }
            }
            else {
                setCustomerData([item]);
                customerData.current = {};
                setSelectedCustomers([]);
                setCustomerPopup({ show: false });
            }
        }
        else {
            if (setCustomerData) {
                item.Name = (item.FirstName ? item.FirstName + " " : "") + item.Name;
                setCustomerData(item);
            }
            if (setCustomerLocation) {
                setCustomerLocation(item.ProvinceID, item.CityID);
            }
            customerData.current = {};
            setSelectedCustomers([]);
            setCustomerPopup({ show: false });
        }
    }
    function inputKeyDown(e) {
        if (e.keyCode === 27) {
            closeModal();
        }
    }
    function changeCustomerType(type) {
        customerData.current.Type = type;
        setCustType(type);
    }
    async function getDefaultAccType() {
        if (defaultAccType === undefined) {
            const settings = await getSystemSettingsAsync(["DefaultAccTypeInCustomerSelect"]);
            const defAccType = getSettingValue(settings, "DefaultAccTypeInCustomerSelect");
            if (defAccType === "" || defAccType?.toLocaleLowerCase() === "default") {
                setAccType("");
            }
            else {
                setAccType(JSON.parse(defAccType));
            }
        }

    }
    useEffect(() => {
        if (show) {
            const inputCustName = refInputCustName.current;
            if (inputCustName) {
                inputCustName.focus();
                if (value && value !== '') {
                    inputCustName.value = value;
                }
            }
            if (!provinceList || provinceList === "" || provinceList.length === 0)
                dispatch(getAllProvinces());
            if (defaultAccType !== "" && defaultAccType !== undefined) {
                setAccType(JSON.parse(defaultAccType));
            }
            else {
                getDefaultAccType();
            }
        }
    }, [show])
    return (
        <Modal show={show} size='xl' style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faListAlt} size='lg' /> &nbsp;
                    انتخاب {title} از لیست
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={closeModal} />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <Accordion defaultActiveKey="1">
                    {!justStaff && !justForSelect &&
                        <Card style={{ background: "#ffffff75", border: "2px solid white" }}>
                            <Accordion.Toggle as={Card.Header} eventKey="0" style={{ backgroundColor: "#999da5" }}>
                                <PersonPlus size={20} />&nbsp;
                                تعریف طرف حساب
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <div className="row">
                                        <div className="form-group col-md-4">
                                            <select className="form-control" name="Type" onChange={e => changeCustomerType(e.target.value)} >
                                                <option value="">نوع طرف حساب</option>
                                                <option value="حقوقی">حقوقی</option>
                                                <option value="مرد">مرد</option>
                                                <option value="زن">زن</option>
                                            </select>
                                            {err.Type && <small className="errors">انتخاب نوع اجباری است</small>}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <select className="form-control" name="Type" onChange={e => setAccType(e.target.value)} value={accType}>
                                                <option value="">ماهیت طرف حساب</option>
                                                <option value={true}>بدهکار</option>
                                                <option value={false}>بستانکار</option>
                                            </select>
                                            {err.Type && <small className="errors">انتخاب نوع اجباری است</small>}
                                        </div>
                                        {custType !== "حقوقی" &&
                                            <div className="form-group col-md-4">
                                                <input className="form-control" type="text" placeholder="نام طرف حساب" onChange={e => customerData.current.FirstName = e.target.value} />
                                                {err.FirstName && <small className="errors">نام را وارد کنید</small>}
                                            </div>
                                        }
                                        <div className="form-group col-md-4">
                                            <input className="form-control" type="text" placeholder={(custType === "حقوقی" ? "نام" : "نام خانوادگی") + " طرف حساب"} onChange={e => customerData.current.Name = e.target.value} />
                                            {err.Name && <small className="errors">{custType === "حقوقی" ? "نام" : "نام خانوادگی"} را وارد کنید</small>}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <input className="form-control" type="number" lang='en' placeholder={custType === "حقوقی" ? "شناسه ملی" : "کد ملی"} onChange={e => customerData.current.NationalCode = e.target.value}></input>
                                            {err.NationalCode && <small className="errors">{custType === "حقوقی" ? "شناسه ملی" : "کد ملی"} ملی معتبر نیست</small>}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <input className="form-control" type="number" lang='en' placeholder="شماره همراه" onChange={e => customerData.current.Mobile = e.target.value} />
                                            {err.Mobile && <small className="errors">تلفن همراه یا ثابت باید وارد شود</small>}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <input className="form-control" type="number" lang='en' placeholder="تلفن ثابت" onChange={e => customerData.current.Phone = e.target.value} />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <select className="form-control" name="ProvinceID" onChange={e => { customerData.current.ProvinceID = e.target.value; loadCityList(e.target.value) }} >
                                                <option value="">انتخاب استان</option>
                                                {provinceList && Array.isArray(provinceList) && provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                            </select>
                                        </div>
                                        <div className="form-group col-md-4">
                                            <select className="form-control" name="CityID" placeholder="شهر" onChange={e => customerData.current.CityID = e.target.value}>
                                                <option value="">انتخاب شهر</option>
                                                {cityList && Array.isArray(cityList) && cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                            </select>
                                        </div>
                                        <Col md={4} className='form-group'>
                                            <Form.Control placeholder='کد اقتصادی' onChange={e => customerData.current.ComercialCode = e.target.value} />
                                        </Col>
                                        <Col md={4} className='form-group'>
                                            <Form.Control placeholder='کد پستی' onChange={e => customerData.current.PostalCode = e.target.value} />
                                        </Col>
                                    </div>
                                    <div className="row">
                                        <div className="form-group" >
                                            <textarea className="form-control" placeholder="نشانی طرف حساب" onChange={e => customerData.current.Address = e.target.value} />
                                            {err.Address && <small className="errors">نشانی اجباری است</small>}
                                        </div>
                                    </div>
                                    <div className="mt-1" style={{ margin: "auto" }}>
                                        <Button className='group-Btn' variant='success' onClick={() => submit()} disabled={isPending}> <CheckLg size={17} />&nbsp;ثبت سریع</Button>
                                        <Button className='group-Btn' onClick={() => submit(true)} variant='info' disabled={isPending}><Check2All size={18} />&nbsp;ثبت و تکمیل اطلاعات</Button>
                                    </div>

                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    }
                    <Card style={{ background: "#ffffff75", border: "2px solid white" }}>
                        <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "#239fcf" }}>
                            <Search size={18} />
                            &nbsp;
                            جستجوی {title}
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <form onSubmit={handleSubmit(search)}>
                                    <div className="row mt-2">
                                        <Col md={3} xs={6}>
                                            <input type="text" placeholder="کد حساب" className="search-input" name="Code" ref={register({})} />
                                        </Col>
                                        <Col Col md={3} xs={6}>
                                            <input type="text" placeholder="نام/نام خانوادگی" className="search-input"
                                                name="Name" onKeyDown={inputKeyDown} ref={(e) => {
                                                    register(e);
                                                    refInputCustName.current = e;
                                                }} />
                                        </Col>
                                        <Col md={3} xs={6}>
                                            <input type="number" placeholder="شماره همراه" className="search-input"
                                                name="Mobile" ref={register({})} onKeyDown={inputKeyDown} />
                                        </Col>
                                        <Col md={3} xs={6}>
                                            <input type="number" placeholder="شماره تلفن" className="search-input"
                                                name="Phone" ref={register({})} onKeyDown={inputKeyDown} />
                                        </Col>
                                        <Col md={3} xs={6}>
                                            <input type="text" placeholder="کد ملی" className="search-input" name="NationalCode" ref={register({})} />
                                        </Col>
                                        <Col md={3} xs={6}>
                                            <input type="text" placeholder="کد اشتراک" className="search-input" name="SubscriptionCode" ref={register({})} />
                                        </Col>
                                        <Col md={3} xs={6}>
                                            <input type="text" placeholder="نشانی" className="search-input"
                                                name="Address" ref={register({})} onKeyDown={inputKeyDown} />
                                        </Col>
                                        <Col md={3} xs={6} >
                                            <select className="search-input" name="CustomerAccountType" ref={register({})} value={accType} onChange={e => setAccType(e.target.value)}>
                                                <option value="">ماهیت حساب را انتخاب کنید</option>
                                                <option value={true}>بدهکار </option>
                                                <option value={false}>بستانکار </option>
                                            </select>
                                        </Col>
                                    </div>
                                    <button className="btn btn-primary w-100 mt-2 mb-1"><Search />&nbsp;&nbsp;جستجوی {title}</button>
                                </form>
                                <BihamtaTable tableRef={resultTable} columns={tableCols} dataList={customerList} maxHeight={325} style={{ whiteSpace: "nowrap" }}
                                    pageSizeList={[10, 20, 50, 100, 200]} defaultPageSize={100} searchMethod={search} filterData={searchData.current} rowButtons={rowButtons}
                                    rowClick={select} />
                                {multiSelect && selectedCustomers?.length > 0 &&
                                    <Button className="group-Btn" variant='info' onClick={() => select()}><Check2Square size={18} /> انتخاب طرف حساب</Button>
                                }
                                {multiSelect && customerList?.Data?.length > 0 &&
                                    <label style={{ color: "blue", position: "absolute", bottom: 8, left: 10, fontSize: "10px" }}>برای انتخاب چند ردیف کلید CTRL را نگه دارید.</label>
                                }
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectCustomer;